// extracted by mini-css-extract-plugin
export default {"tvCard":"TVCard_tvCard__lllf9","tvShortCard":"TVCard_tvShortCard__yMxww","lastDiv":"TVCard_lastDiv__Q+Sbt"};